import { denormalize } from 'normalizr';
import get from 'lodash/get';
import { getStore as getDB } from '/b2b/common/state/db/DB.store';
import schema from './HelpScoutCustomer.schema';

export const DOMAIN = `db.${schema.key}`;

export const getStore = state => get(state, DOMAIN) || {};

export const getEntityById = (state, id) => denormalize(id, schema, getDB(state)) || {};
export const getEntitiesForIds = (state, ids) => denormalize(ids, [schema], getDB(state));
export const getChangesForId = (state, id) => getEntityById(state, id).changes;

export const getEntityFieldById = (state, { id, field }) =>
    get(getStore(state), [id, field]) || null;
